import { Component, HostBinding, OnInit } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  optionsLottie: AnimationOptions = {
    path: 'assets/lottie/loader_animation.json',
  };
  @HostBinding('class.visible') show = false;

  constructor(private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.loaderService.isLoading$.subscribe(state => {
      this.show = state;
    });
  }

}
